import posts from "./posts.generated.json";

export default posts;

export function getPost(slug) {
  return posts.find((p) => p.slug === slug) || null;
}
